/* REQ-069 · Google review count + rating from the Reputon app feed (the "Google Reviews" app on the store).
   Liquid renders the manual numbers (theme settings); this swaps in the app's numbers when they are valid:
   [data-pm-gr="count"] / [data-pm-gr="rating"] text, and the aria-label on [data-pm-gr-label] (data-pm-gr-tpl, {r}/{n}).
   Stars match the shown rating (r3, Ran 03.11: "אין סיבה להסתיר גם אם זה יורד מ5.0"): full, partial and empty, on the
   home hero ([data-pm-gr="stars"], SVG), the PDP summary ([data-pm-gr="stars"], text ★) and the PDP stars row under the
   title ([data-pm-stars] > span, text ★). The line is never hidden because of the rating.
   Home hero: after window load. PDP reviews: when the section is near the viewport ([data-pm-gr-lazy]), unless the
   PDP stars row ([data-pm-stars], filled once from .pm-rv__sum by pampas-pdp-layout.js) is on the page: it is above
   the fold, so then after load too, and the row is refreshed from the updated summary.
   Any failure (network, 4s timeout, bad JSON, other business, stale feed) keeps the manual numbers; the stars then
   follow the manual rating. The endpoint is the app's undocumented storefront call (same URL as layout/theme.liquid). */
(function () {
  if (window.pmGoogleRating) return;
  var URL_ = 'https://grw.reputon.com/app/storefront/widget?shop=xi3681-76.myshopify.com&lang=he';
  var CID = 'cid=16054529616532980903'; // the store's Google place (same as the PDP google_url)
  var KEY = 'pm_gr_v2', TTL = 30 * 60 * 1000, MAX_AGE = 45 * 86400;
  var SVGNS = 'http://www.w3.org/2000/svg';
  var fmt = function (n) { return new Intl.NumberFormat('en-US').format(n); };
  var pending = null, uid = 0;

  function pick(payload) {
    if (!payload || !Array.isArray(payload.business)) return null;
    var updated = Number(payload.updatedTime);
    if (!(updated > 0) || Date.now() / 1000 - updated > MAX_AGE) return null;
    var b = null;
    for (var i = 0; i < payload.business.length; i++) {
      var x = payload.business[i];
      if (x && typeof x.url === 'string' && x.url.indexOf(CID) !== -1) { b = x; break; }
    }
    if (!b) return null;
    var n = b.reviewsNumber, r = b.rating;
    if (typeof n !== 'number' || n % 1 !== 0 || n < 100 || n > 100000) return null;
    if (typeof r !== 'number' || !(r >= 1 && r <= 5)) return null;
    return { n: fmt(n), r: r.toFixed(1) };
  }

  function readCache() {
    try {
      var c = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (c && c.t && Date.now() - c.t < TTL && typeof c.n === 'string' && typeof c.r === 'string') return { n: c.n, r: c.r };
    } catch (e) {}
    return null;
  }
  function writeCache(v) {
    try { sessionStorage.setItem(KEY, JSON.stringify({ t: Date.now(), n: v.n, r: v.r })); } catch (e) {}
  }

  function load() {
    var c = readCache();
    if (c) return Promise.resolve(c);
    if (pending) return pending;
    if (!window.fetch || !window.Promise) return Promise.resolve(null);
    var ctl = window.AbortController ? new AbortController() : null;
    var timer = setTimeout(function () { if (ctl) ctl.abort(); }, 4000);
    pending = fetch(URL_, { mode: 'cors', credentials: 'omit', signal: ctl ? ctl.signal : undefined })
      .then(function (res) { if (!res.ok) throw new Error('status ' + res.status); return res.json(); })
      .then(function (p) { var v = pick(p); if (v) writeCache(v); return v; })
      .catch(function () { return null; })
      .then(function (v) { clearTimeout(timer); pending = null; return v; });
    return pending;
  }

  /* stars, rating r (1..5): star k is filled by clamp(r - k, 0, 1), counted from the right (Hebrew reading order), so a
     partial star sits at the left end, next to the number. The hero row lays its SVGs out direction:ltr. */
  function fill(r, k) { return Math.max(0, Math.min(1, r - k)); }
  // SVG stars (home hero): a per-star gradient, gold to a translucent empty colour
  function paintSvg(box, r) {
    var svgs = box.querySelectorAll('svg');
    svgs.forEach(function (svg, i) {
      var f = fill(r, svgs.length - 1 - i), path = svg.querySelector('path'); if (!path) return;
      if (f >= 1) { path.removeAttribute('fill'); return; } // the svg's own gold fill
      var g = svg.querySelector('linearGradient');
      if (!g) {
        var defs = document.createElementNS(SVGNS, 'defs'); g = document.createElementNS(SVGNS, 'linearGradient');
        g.id = 'pmgr' + (++uid); g.setAttribute('x1', '1'); g.setAttribute('x2', '0'); // gold from the right
        for (var i = 0; i < 4; i++) g.appendChild(document.createElementNS(SVGNS, 'stop'));
        defs.appendChild(g); svg.insertBefore(defs, svg.firstChild);
      }
      var s = g.querySelectorAll('stop'), gold = svg.getAttribute('fill') || '#F2C14E', empty = 'rgba(255,255,255,.45)';
      [[0, gold], [f, gold], [f, empty], [1, empty]].forEach(function (o, i) { s[i].setAttribute('offset', o[0]); s[i].setAttribute('stop-color', o[1]); });
      path.setAttribute('fill', 'url(#' + g.id + ')');
    });
  }
  // text stars (★★★★★, PDP): the glyphs clipped to a gold-to-empty gradient; the stop sits inside the partial star's
  // own glyph (each of the 5 advances = glyph + letter-spacing), so 4.8 really shows 80% of the fifth star
  function paintText(el, r) {
    if (r >= 5) { ['background-image', '-webkit-background-clip', 'background-clip', '-webkit-text-fill-color'].forEach(function (k) { el.style.removeProperty(k); }); return; }
    el.style.display = 'inline-block'; el.style.direction = 'ltr'; el.style.unicodeBidi = 'isolate';
    var w = el.getBoundingClientRect().width, ls = parseFloat(getComputedStyle(el).letterSpacing) || 0;
    // measured from the right edge; each advance's letter-spacing trails on the right of its glyph (direction:ltr)
    var adv = w / 5, k = Math.floor(r), x = ls + k * adv + (r - k) * Math.max(0, adv - ls);
    var stop = w > 0 ? Math.round(x * 10) / 10 + 'px' : Math.round(r / 5 * 1000) / 10 + '%';
    el.style.backgroundImage = 'linear-gradient(270deg, currentColor ' + stop + ', #DDD3C8 ' + stop + ')';
    el.style.setProperty('-webkit-background-clip', 'text'); el.style.setProperty('background-clip', 'text');
    el.style.setProperty('-webkit-text-fill-color', 'transparent');
  }
  function paintStars(root) {
    var rr = root.querySelector('[data-pm-gr="rating"]') || document.querySelector('[data-pm-gr="rating"]');
    var r = rr ? parseFloat(rr.textContent) : NaN;
    if (!(r >= 1 && r <= 5)) return;
    root.querySelectorAll('[data-pm-gr="stars"]').forEach(function (el) { if (el.querySelector('svg')) paintSvg(el, r); else paintText(el, r); });
    document.querySelectorAll('[data-pm-stars] > span[aria-hidden]').forEach(function (el) { paintText(el, r); });
  }

  function apply(root, v) {
    if (v) {
      root.querySelectorAll('[data-pm-gr="count"]').forEach(function (el) { if (el.textContent !== v.n) el.textContent = v.n; });
      root.querySelectorAll('[data-pm-gr="rating"]').forEach(function (el) { if (el.textContent !== v.r) el.textContent = v.r; });
      root.querySelectorAll('[data-pm-gr-label]').forEach(function (el) {
        var t = el.getAttribute('data-pm-gr-tpl');
        if (t) el.setAttribute('aria-label', t.replace('{r}', v.r).replace('{n}', v.n));
      });
    }
    syncStars();
    paintStars(root);
  }

  // the PDP stars row copies the summary's text (same rule as pampas-pdp-layout.js stars()); refresh it once filled
  function syncStars() {
    var sum = document.querySelector('.pm-rv .pm-rv__sum[data-pm-gr-line]');
    if (!sum) return;
    document.querySelectorAll('[data-pm-stars]').forEach(function (a) {
      var u = a.querySelector('u');
      if (!a.dataset.done || !u) return;
      var t = sum.textContent.replace(/★/g, '').trim();
      if (u.textContent !== t) { u.textContent = t; a.setAttribute('aria-label', 'ביקורות: ' + t); }
    });
  }

  function run(root) {
    if (!root.querySelector('[data-pm-gr]')) return;
    var lazy = root.matches && root.matches('[data-pm-gr-lazy]') ? root : root.querySelector('[data-pm-gr-lazy]');
    var go = function () { load().then(function (v) { apply(root, v); }); };
    if (lazy && !document.querySelector('[data-pm-stars]') && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        if (es.some(function (e) { return e.isIntersecting; })) { io.disconnect(); go(); }
      }, { rootMargin: '600px 0px' });
      io.observe(lazy);
    } else if (document.readyState === 'complete') {
      go();
    } else {
      window.addEventListener('load', go, { once: true });
    }
  }

  window.pmGoogleRating = { pick: pick, run: run }; // pick is exposed for QA only
  run(document);
  // theme editor: a reloaded section brings new markup with the manual numbers
  document.addEventListener('shopify:section:load', function (e) { run(e.target); });
})();
